<template>
  <div class="hotels_box">
    <HomeHeader />
    <div style="height: 70px;"></div>
    <div class="hotel_header">
      <SearchForm btnText="更新" @toSerch="init()" />
    </div>
    <div class="hotels_body">
      <div></div>
      <div>
        <div class="filter_box">
          <div class="filter_box_item" v-show="homeSearchForm && !homeSearchForm.poiType">
            <div class="filter_box_title">
              <span class="address_text">{{ $t('hotel_list.location') }}</span>
            </div>
            <div class="address">
              <div class="address_sel" :class="addressShow == 0 ? 'check_add' : ''" @click="changeAddressFilter(0)">{{
                $t('hotel_list.unlimited')
              }}
              </div>
              <div class="address_sel" :class="addressShow == 1 ? 'check_add' : ''" @click="changeAddressFilter(1)">
                {{ $t('hotel_list.downtown') }}
              </div>
              <div class="address_sel" :class="addressShow == 2 ? 'check_add' : ''" @click="changeAddressFilter(2)">
                {{ $t('hotel_list.district') }}
              </div>
            </div>
          </div>

          <div class="address_filter_box" v-show="addressShow != 0">
            <div v-show="addressShow == 1">
              <span class="bizZoneName_item" v-for="(item, index) in bizZoneName" :key="index"
                :class="item.poiCn == selBizZoneName ? 'sel' : ''" @click="checkAddress(1, item.poiCn)">{{ item.poiCn }}</span>
            </div>
            <div v-show="addressShow == 2">
              <span class="bizZoneName_item" v-for="(item, index) in districtName" :key="index"
                :class="item.districtNameCn == selDistrictName ? 'sel' : ''" @click="checkAddress(2, item.districtNameCn)">{{ item.districtNameCn }}</span>
            </div>
          </div>

          <div class="filter_box_item">
            <div class="filter_box_title">
              <span>{{ $t('hotel_list.hotel_stars') }}</span>
            </div>
            <div class="start">
              <span @click="checkRating(0)" :class="starRating.length ? '' : 'sel_all'">{{
                $t('hotel_list.unlimited')
              }}</span>
              <span class="star_item" v-for="(item, index) in ratingList" :key="index" :class="item.status ? 'sel' : ''"
                @click="checkRating(item)">{{ item.text }}</span>
            </div>
          </div>

          <div class="filter_box_item">
            <div class="filter_box_title">
              <span>{{ $t('hotel_list.price_per_night') }}</span>
            </div>
            <div class="price">
              <span @click="checkPrice(0)" :class="isSelPrice ? '' : 'sel_price'">{{
                $t('hotel_list.unlimited')
              }}</span>
              <span class="price_item" :class="item.status ? 'sel' : ''" v-for="(item, index) in priceList" :key="index"
                @click="checkPrice(item)">{{ item.name }}</span>
            </div>
          </div>

          <div style="height: 70px;line-height: 70px;padding-left: 30px;font-size: 16px;">

            {{ $t('hotel_list.current') }},
            <span style="color:#1e50f0;font-size:20px;font-weight:600;">{{ data.total ? data.total : 0 }}</span>
            {{ $t('hotel_list.hotel_counts') }}
          </div>
        </div>
        <div class="sort_box">
          <span class="sort_item" :class="sortBy === 5 ? 'active' : ''" @click="changeSortMethods(5)">智能排序</span>
          <span class="sort_item" :class="sortBy === 3 ? 'active' : ''" @click="changeSortMethods(3)">价格（高-低）</span>
          <span class="sort_item" :class="sortBy === 2 ? 'active' : ''" @click="changeSortMethods(2)">价格（低-高）</span>
          <span class="sort_item" :class="!sortBy ? 'active' : ''" @click="changeSortMethods(null)"
                v-if="homeSearchForm && homeSearchForm.poiType">
            按距离
          </span>
        </div>
        <div class="hotel_list_box" v-loading="loading">
          <div v-if="data.hotels.length">
            <div class="hotel_item" v-for="(item, index) in data.hotels" :key="index">
              <div class="hotel_img">
                <img :src="item.hotelImages" v-if="item.hotelImages">
                <div class="no_img" v-else>
                  <img src="../../../assets/newImage/noSwiperImg1.png">
                </div>
              </div>
              <div class="info">
                <div class="hotem_name">
                  {{ item.nameCn }}<span v-if="item.nameEn">-</span><span style="font-size: 16px;color: grey;font-weight: normal">{{ item.nameEn }}</span>
                </div>
                <div style="display: flex;align-items: center;margin-bottom: 15px;column-gap: 15px">
                  <div class="hotel_star" v-if="item.star">
                    <el-rate v-model="item.star" disabled></el-rate>
                    <span>{{ item.starText }}</span>
                  </div>
                  <div class="hotel_star" v-if="!item.star && item.category">
                    <el-rate v-model="item.category" disabled disabled-void-icon-class="iconfont icon-zuanshi"
                             :icon-classes="['iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi']"></el-rate>
                    <span>{{ $commonUtil.getCategoryDesc(item.category) }}</span>
                  </div>
                  <div class="hotel_star" v-if="!item.star && !item.category">
                    <el-rate :value="2" disabled></el-rate>
                    <span>{{ item.starText }}</span>
                  </div>
                  <div class="hotel_desc">
                    {{ $commonUtil.getScoreDesc(item.score) }}
                  </div>
                </div>
                <div class="hotel_address">
                  <div style="display: flex;align-items: center;column-gap: 2px">
                    <img src="../../../assets/img/图层 10.png" style="width:15px;height:15px;">
                    <span>{{ item.addressCn }}</span>
                  </div>
                  <span v-if="!!homeSearchForm.poiType">
                    距地标{{ distanceLgorthm(item.longitude, item.latitude) }}公里
                  </span>
                </div>
                <div class="hotel_address">
                  <div class="hotel_facility">
                    <span v-for="(item, index) in getFacilities(item.hotelFacilities)" :key="index" class="fac_item">
                      <span style="color: #4b5563">
                        {{ item }}
                      </span>
                    </span>
                  </div>
                </div>
                <div class="hotel_desc_box">
                  {{ item.hotelDescCn }}
                </div>
                <div class="hotel_price">
                  <div v-if="item.price" style="color: #f97316;margin-bottom: 15px;text-align: right;font-size: 16px;font-weight: 600">
                    ￥{{ item.price }}
                    <span v-html="isLang ? '' : '起 / 晚'" style="font-size: 12px;color: #6f7782"></span>
                  </div>
                  <div v-else style="color: #9b9999;margin-bottom: 15px;text-align: right;font-size: 16px;font-weight: 600">
                    已售罄
                  </div>
                  <b2b-button @click="toHotelDetail(item)" style="width: 120px;height: 35px;line-height: 35px">{{ $t('hotel_list.view_details') }}</b2b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="hotel_list_null" v-else>
            <div class="info">
              <img src="../../../assets/img/hotel-search-no.png">
              <p>{{ $t('hotel_list.no_hotels') }}</p>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination :current-page="data.current" :page-size="data.size" layout="total, prev, pager, next, jumper"
            :total="data.total" @current-change="pageChange" :hide-on-single-page="true">
          </el-pagination>
        </div>
      </div>
      <div></div>
    </div>
    <ContantUs style="background-color: #fff;margin-top: 50px;" />
    <footerInfo />
  </div>
</template>

<script>
import HomeHeader from './components/HomeHeader.vue';
import SearchForm from './components/SearchForm.vue';
import ContantUs from './components/ContantUs.vue';
import footerInfo from '../frame/footerInfo.vue';
export default {
  data () {
    return {
      data: {
        current: 1,
        hotels: [],
        size: 10,
        total: 0
      },
      loading: false,
      scoreTextMap: {
        '5.0': '超级棒',
        '5': '超级棒',
        '4.9': '非常棒',
        '4.8': '棒',
        '4.7': '很好',
        '4.6': '好',
        '4.5': '不错'
      },
      // 行政区
      districtName: [],
      // 商业区
      bizZoneName: [],
      addressShow: 0,
      selDistrictName: '',
      selBizZoneName: '',
      // 酒店区间
      starRating: [],
      ratingList: [{
        text: this.$t('hotel_list.below_two_stars'),
        value: 2,
        status: false
      }, {
        text: this.$t('hotel_list.three_star'),
        value: 3,
        status: false
      }, {
        text: this.$t('hotel_list.four_star'),
        value: 4,
        status: false
      }, {
        text: this.$t('hotel_list.five_star'),
        value: 5,
        status: false
      }],
      // 价格区间
      priceList: [{
        name: this.$t('hotel_list.less_than_200'),
        maxPrice: 200,
        status: false
      }, {
        name: this.$t('hotel_list.200_500'),
        maxPrice: 500,
        minPrice: 200,
        status: false
      }, {
        name: this.$t('hotel_list.500_1000'),
        maxPrice: 1000,
        minPrice: 500,
        status: false
      }, {
        name: this.$t('hotel_list.1000_2000'),
        maxPrice: 2000,
        minPrice: 1000,
        status: false
      }, {
        name: this.$t('hotel_list.more_than_2000'),
        minPrice: 2000,
        status: false
      }],
      priceReq: {
        maxPrice: undefined,
        minPrice: undefined
      },
      homeSearchForm: {},
      sortBy: 5
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.toSerch(true)
      this.getCityDistrict()
    },
    changeSortMethods (e) {
      this.sortBy = e
      this.toSerch(true, false, true)
    },
    async toSerch (type, fromAddress, fromSortMethod) {
      if (type) {
        this.data.current = 1
      }
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (!this.homeSearchForm) return
      this.homeSearchForm = homeSearchForm
      let reqData = {
        businessZone: this.selBizZoneName,
        checkIn: homeSearchForm.checkIn,
        cityCode: homeSearchForm.cityCode,
        keyword: homeSearchForm.keyword,
        district: this.selDistrictName,
        pageInx: this.data.current,
        pageSize: this.data.size,
        sortBy: this.sortBy,
        starRating: this.starRating,
        regionId: homeSearchForm.regionId,
        poiType: !!homeSearchForm.poiType,
        cityType: !!homeSearchForm.cityType,
        userLatitude: homeSearchForm.latitude,
        userLongitude: homeSearchForm.longitude,
        countryCode: homeSearchForm.countryCode,
        ...this.priceReq
      }
      // 添加价格区间
      let reqHeader = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      this.data.hotels = [];
      document.documentElement.scrollTop = 0
      this.loading = true
      let partnerInfo = JSON.parse(this.$common.isLogin())
      if (!partnerInfo) {
        reqData.defaultUser = true
      }
      const { data: result } = await this.$http.post('/mini/searchCityHotels', reqData, { headers: reqHeader })
      this.loading = false
      if (result.code != 200) return this.$message.error(result.message)
      this.data = result.data
    },
    pageChange (e) {
      this.data.current = e;
      this.toSerch()

    },
    async getCityDistrict () {
      const homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (!homeSearchForm) return
      let reqHeader = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      const { data: result } = await this.$http.get(`mini/getCityDistrict?cityCode=${homeSearchForm.cityCode}`, { headers: reqHeader })
      if (result.code != 200) return
      try {
        this.districtName = JSON.parse(result.data.districtName)
      } catch (e) {
        this.districtName = []
      }
      this.bizZoneName = result.data.bizZoneName ? JSON.parse(result.data.bizZoneName) : []
      this.addressShow = 0
    },
    changeAddressFilter (e) {
      if (e == 0) {
        this.selDistrictName = ''
        this.selBizZoneName = ''
        this.toSerch(true)
      }
      this.addressShow = e
    },
    checkAddress (type, item) {
      if (type == 1) {
        this.selBizZoneName = item
        this.selDistrictName = ''
      } else {
        this.selDistrictName = item
        this.selBizZoneName = ''
      }
      this.toSerch(true, true)
    },
    checkRating (e) {
      // 选择全部
      if (e == 0) {
        this.ratingList.forEach(item => {
          item.status = false
        })
        this.starRating = []
      } else {
        // 星级选择
        this.ratingList.forEach(item => {
          // 将当前选择的item status取反
          if (item.value == e.value) {
            item.status = !item.status
            // 取反后为true
            if (item.status) {
              // 若不存在starRating中 则添加
              if (this.starRating.indexOf(item.value) == -1) {
                this.starRating.push(item.value)
              }
            } else {
              // 取反后为false 说明已经被添加至starRating中 则需要删除
              let delIndex = this.starRating.findIndex(i => i == item.value)
              this.starRating.splice(delIndex, 1)
            }
          }
        })
      }
      this.toSerch(true)
    },
    checkPrice (e) {
      if (e == 0) {
        this.priceReq.maxPrice = undefined
        this.priceReq.minPrice = undefined
        this.priceList.forEach(item => item.status = false)
      } else {
        this.priceReq.maxPrice = e['maxPrice']
        this.priceReq.minPrice = e['minPrice']
        this.priceList.forEach(item => {
          if (item.name == e.name) {
            item.status = true
          } else {
            item.status = false
          }
        })
      }
      this.toSerch(true)
    },
    toHotelDetail (e) {
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      let obj = {
        room: homeSearchForm.room,
        adult: homeSearchForm.adult,
        checkDates: homeSearchForm.checkDates,
        checkIn: homeSearchForm.checkIn,
        checkOut: homeSearchForm.checkOut,
        keyword: homeSearchForm.keyword,
        name: homeSearchForm.name,
        cityCode: homeSearchForm.cityInfo ? homeSearchForm.cityInfo.cityCode : '',
        countryCode: homeSearchForm.countryCode,
        channelId: null,
        regions: [],
        stars: [0],
        price: 0,
        siteType: 0,
        districtName: null,
        bizZoneName: null,
        starRating: null,
        hotelId: e.hotelId,
      }
      localStorage.setItem('hotelDetailSearchForm', JSON.stringify(obj))
      window.open('/HotelDetail', '_blank');
      // this.$router.push('/HotelDetail')
    },
    distanceLgorthm(longitude, latitude) {
      const EARTH_RADIUS = 6378137
      let degree_lat1 = (this.homeSearchForm.latitude * Math.PI) / 180.0
      let degree_lat2 = (latitude * Math.PI) / 180.0
      let a = degree_lat1 - degree_lat2
      let degree_lng1 = (this.homeSearchForm.longitude * Math.PI) / 180.0
      let degree_lng2 = (longitude * Math.PI) / 180.0
      let b = degree_lng1 - degree_lng2
      // 距离 （单位：米）
      let s = 2 * Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
          Math.cos(degree_lat1) *
          Math.cos(degree_lat2) *
          Math.pow(Math.sin(b / 2), 2)
        )
      )
      s = s * EARTH_RADIUS
      s = Math.round(s * 10000) / 10000
      return (s / 1000).toFixed(1)
    },
    getFacilities (hotelFacilities) {
      if (!hotelFacilities) return []
      return hotelFacilities.slice(0, 6).map(item => item.cn)
    },
  },
  components: {
    HomeHeader,
    SearchForm,
    ContantUs,
    footerInfo
  },
  computed: {
    isSelPrice () {
      return this.priceList.some(item => item.status)
    },
    isLang () {
      return localStorage.getItem('lang') == 'en'
    }
  }
}
</script>

<style lang="less" scoped>
.hotels_box {
  min-height: 100vh;
  min-width: 100%;
  background-color: #f5f7fa;

  .hotel_header {
    width: 100%;
    height: 290px;
    background-image: url('../../../assets/newImage/bg_new.png');
    background-size: 100%;
    padding: 24px 0;
    background-position: center top -240px;
  }

  .hotels_body {
    display: grid;

    @media screen and (min-width: 992px) {
      grid-template-columns: auto 1180px auto;
    }

    @media screen and (max-width: 992px) {
      grid-template-columns: 10% 1fr 10%;
    }

    .filter_box {
      margin-top: 30px;
      background-color: #fff;
      box-shadow: 0 2px 6px rgba(44, 55, 66, .15);

      .filter_box_item {
        border-bottom: 1px solid #dadfe6;
        font-size: 13px;

        .filter_box_title {
          text-align: center;
          background-color: #f0f2f5;
          font-size: 13px;
        }

      }

      .address_filter_box {
        padding: 20px;
        transition: all .5s ease;

        .bizZoneName_item {
          display: inline-block;
          font-size: 13px;
          background-color: #f5f7f9;
          padding: 10px;
          margin: 5px;
          cursor: pointer;

          &:hover {
            background-color: #b7c4eee0;
            color: #000;
          }
        }

        .bizZoneName_item.sel {
          background-color: #1e50f0;
          color: #fff;
        }
      }

      .filter_box_item:first-child {
        display: flex;

        .filter_box_title {
          width: 120px;
          min-height: 70px;
          position: relative;
        }

        .address_text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .address {
          padding-left: 20px;
          flex: 1;
          display: grid;
          grid-template-columns: repeat(3, 100px);
          align-items: center;

          .address_sel {
            cursor: pointer;
            user-select: none;
          }

          .address_sel.check_add {
            color: #1e50f0;
          }
        }
      }

      .filter_box_item:not(:first-child) {
        display: grid;
        grid-template-columns: 120px 1fr;
        grid-template-rows: 70px;

        .filter_box_title {
          display: grid;
          align-items: center;
        }

        .start {
          padding-left: 20px;
          display: grid;
          grid-template-columns: 60px max-content repeat(3, max-content);
          grid-column-gap: 15px;
          align-items: center;

          span {
            cursor: pointer;
            user-select: none;
          }

          .sel_all {
            color: #1e50f0;
          }

          .star_item {
            background-color: #f5f7f9;
            padding: 10px 14px;
            text-align: center;

            &:hover {
              background-color: #b7c4eee0;
              color: #000;
            }
          }

          .star_item.sel {
            background-color: #1e50f0;
            color: #fff;
          }
        }

        .price {
          padding-left: 20px;
          display: grid;
          grid-template-columns: 60px repeat(5, max-content);
          grid-column-gap: 10px;
          align-items: center;

          span {
            cursor: pointer;
            user-select: none;
          }

          .sel_price {
            color: #1e50f0;
          }

          .price_item {
            background-color: #f5f7f9;
            padding: 10px 12px;
            text-align: center;

            &:hover {
              background-color: #b7c4eee0;
              color: #000;
            }
          }

          .price_item.sel {
            background-color: #1e50f0;
            color: #fff;
          }
        }
      }
    }

    .sort_box {
      margin-top: 30px;
      background-color: #fff;
      padding: 15px 30px;
      display: flex;
      column-gap: 15px;

      .sort_item {
        cursor: pointer;
        font-size: 14px;
        display: flex;
        column-gap: 10px;

        &.active {
          color: #1e50f1;
          font-weight: bolder;
        }

        &:not(:last-child) {
          &::after {
            content: '';
            display: block;
            width: 1px;
            height: 15px;
            background-color: #d7d7d7;
          }
        }
      }
    }

    .hotel_list_box {

      .hotel_item {
        margin-bottom: 15px;
        background-color: #fff;
        padding: 20px;

        display: grid;
        grid-template-columns: 25% 1fr;
        grid-column-gap: 30px;

        transition: all .4s ease-in-out;

        &:first-child {
          border-radius: 0 0 8px 8px;
        }

        &:not(:first-child) {
          border-radius: 8px;
        }

        &:hover {
          box-shadow: 0 2px 36px rgba(44, 55, 66, .15);
        }

        .hotel_img {

          width: 100%;
          height: 200px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }

          .no_img {
            width: 100%;
            height: 200px;
            position: relative;
            border-radius: 8px;
            overflow: hidden;

            img {
              filter: blur(1.5px);
              transform: scale(1.03);
            }

            &::before {
              content: '暂无图片';
              color: #fff;
              font-size: 14px;
              font-family: '苹方';
              font-weight: 600;
              letter-spacing: 1px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 99;
            }
          }
        }

        .info {
          position: relative;
          font-family: '微软雅黑';

          .hotem_name {
            font-size: 20px;
            font-weight: 600;
            word-break: break-all;
            margin-bottom: 10px;
          }

          .hotel_star {
            display: grid;
            grid-template-columns: repeat(2, max-content);
            align-items: center;
            grid-column-gap: 6px;
            font-size: 13px;
            color: #8c8c8c;
          }

          .hotel_address {
            font-size: 13px;
            color: #333333;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            column-gap: 10px;

            .hotel_facility {
              display: flex;
              column-gap: 10px;

              .fac_item {
                padding: 4px 8px;
                background-color: #FFFFFF;
                border-radius: 4px;
                border: 1px solid #dde0e5;
                color: #000000;
              }
            }
          }

          .hotel_desc {
            color: #f7ba2a;
            font-size: 15px;
            font-weight: 600;
          }

          .hotel_desc_box {
            width: 550px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            color: #616976;
          }

          .hotel_price {
            color: #1e50f0;
            position: absolute;
            right: 0;
            bottom: 0;

            //display: grid;
            //grid-template-columns: auto auto;
            //grid-column-gap: 25px;
            //align-items: center;

            div:first-child {
              font-size: 20px;
            }

            /deep/ .b2b_button {
              width: max-content;
              padding: 0 20px;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
            }
          }
        }
      }

      .hotel_list_null {
        height: 300px;
        background-color: #fff;
        position: relative;

        .info {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;

          p {
            font-size: 13px;
            margin-top: 8px;
          }
        }
      }
    }

    .pagination {
      margin: 50px 0;
      position: relative;

      /deep/ .el-pagination {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/hotelList.vue